import { Cloud, CloudRain, CloudSun, type LucideIcon, Sun } from "lucide-react";

import type { WeatherCondition } from "../types.ts";

export interface WeatherMeta {
	value: WeatherCondition;
	label: string;
	icon: LucideIcon;
}

export const WEATHER_META: Record<WeatherCondition, WeatherMeta> = {
	sun: { value: "sun", label: "Sol", icon: Sun },
	"cloud-sun": {
		value: "cloud-sun",
		label: "Parcial",
		icon: CloudSun,
	},
	cloud: {
		value: "cloud",
		label: "Nublado",
		icon: Cloud,
	},
	"cloud-rain": {
		value: "cloud-rain",
		label: "Chuva",
		icon: CloudRain,
	},
};

export const WEATHER_OPTIONS: WeatherMeta[] = [
	WEATHER_META.sun,
	WEATHER_META["cloud-sun"],
	WEATHER_META.cloud,
	WEATHER_META["cloud-rain"],
];
